import { Component, OnInit } from '@angular/core';
declare let $:any;
@Component({
  selector: 'app-release',
  templateUrl: './release.component.html',
  styleUrls: ['./release.component.scss']
})
export class ReleaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  releaseGroupModal()
  {
    $('#release_group').modal('show');
  }
  releaseStrategyModal()
  {
    $('#release_strategy').modal('show');
  }

}
